/**
 * Beard Animation
 * Cycles through 12 beard SVG frames in a loop using the SVGFrameAnimator class
 */

import { SVGFrameAnimator } from './SVGFrameAnimator.js';

/**
 * Initialize the beard animation when DOM is ready
 */
function initBeardAnimation() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startAnimation);
    } else {
        startAnimation();
    }
}

/**
 * Start the beard animation
 */
function startAnimation() {
    // Create the beard animation using the SVGFrameAnimator class
    const beardAnim = new SVGFrameAnimator('benefit-the-wiz-beard', {
        basePath: '/assets/3_benefits/beard-animation/Beard-',
        frameCount: 12,
        frameFormat: 'sequential', // Frame files are named Beard-1.svg, Beard-2.svg, etc.
        extension: '.svg',
        frameRate: 30, // 30 frames per second (2.5x faster than 12)
        loop: true,
        autoplay: true,
        preload: true,
        imageStyles: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    });

    // Make it globally accessible for debugging/control
    window.beardAnimation = beardAnim;
}

// Start the animation
initBeardAnimation();

// Export for potential module usage
export { initBeardAnimation };
